import makeStyles from '@mui/styles/makeStyles';
import { appPalette } from 'theme/App.palette';
import { appFonts } from 'theme/App.fonts';
import { theme } from 'theme/App.theme';

const {
  light_grey_2,
  off_white,
  light_grey_6,
  white,
  honda_red,
  light_grey_4,
  honda_blue,
  dark_blue_1,
} = appPalette.colors;

export const useStyles = makeStyles({
  root: {
    borderRadius: '0',
    boxShadow: 'none',
    border: `0.0625rem solid ${light_grey_2}`,
    background: '#ffff',
    marginBottom: '0.9375rem',
    padding: '0.9375rem 1.25rem',
    position: 'relative',
    width: '100%',
    ...(theme.themeName === 'honda' && {
      borderRadius: '0.25rem',
    }),
    [theme.breakpoints.up('viewportMedium')]: {
      '&:last-child': {
        marginBottom: '0',
      },
    },
    ...(theme.themeName === 'honda' && {
      '& .is-preferred svg path': {
        fill: honda_red,
      },
    }),
  },
  noBorder: {
    border: 'none',
    borderBottom: `0.125rem solid ${off_white}`,
    [theme.breakpoints.up('viewportMedium')]: {
      border: `0.0625rem solid ${light_grey_2}`,
    },
  },
  dealerHeader: {
    alignItems: 'center',
    padding: '0',
    marginBottom: '0.625rem',
    flexWrap: 'nowrap',
  },
  dealerContent: {
    padding: 0,
    marginBottom: '1.25rem',
  },
  dealerIndex: {
    background: light_grey_6,
    borderRadius: '50%',
    color: white,
    height: '2.1875rem',
    margin: '0',
    minWidth: 'unset',
    width: '2.1875rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ...(theme.themeName === 'honda' && {
      background: 'none',
      borderRadius: '50%',
      height: '2.1875rem',
      width: '1.6875rem',
      position: 'relative',
    }),
  },
  index_text: {
    position: 'relative',
  },
  location_pin: {
    position: 'absolute',
    top: '0.125rem',
    left: 0,
    height: '100%',
    width: '100%',
  },
  dealerTitle: {
    textAlign: 'start',
    margin: '0 0.625rem',
    marginRight: '1.875rem',
    cursor: 'pointer',
    textTransform: 'none',
    background: 'none',
    border: 'none',
    letterSpacing: '0',
    '&:hover': {
      backgroundColor: white,
    },
    ...(theme.themeName === 'honda' && {
      color: dark_blue_1,
    }),
  },
  dealerDistanceMiles: {
    color: light_grey_4,
    ...(theme.themeName === 'honda' && {
      color: honda_blue,
      marginBottom: '0.125rem',
    }),
  },
  directionIcon: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      height: '1.6875rem',
      width: '1.6875rem',
    },
    '& a': {
      borderBottom: 'none',
    },
  },
  telephone: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.up('viewportMobileMid')]: {
      justifyContent: 'flex-start',
    },
    '& svg': {
      height: '1.6875rem',
      width: '1.6875rem',
    },
  },
  dealerDirections: {
    paddingLeft: '1.875rem',
    ...(theme.themeName === 'honda' && {
      color: dark_blue_1,
    }),
    '& a': {
      borderBottom: 'none',
    },
  },
  directionLink: {
    display: 'flex',
    flexDirection: 'row',
    textDecoration: 'none',
    borderBottom: 'none',
    '& .cta-label': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'left',
    },
  },
  telephoneLink: {
    display: 'flex',
    flexDirection: 'row',
    textDecoration: 'none',
    borderBottom: 'none',
    '& .cta-label': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'left',
    },
  },
  telephoneText: {
    display: 'none',
    [theme.breakpoints.up('viewportMobileMid')]: {
      display: 'flex',
      marginLeft: '0.625rem',
    },
  },
  preferredButton: {
    position: 'absolute',
    top: '-0.0390625rem',
    padding: '0',
    right: '0.625rem',
    height: '2.625rem',
    width: '2.625rem',
    '& svg': {
      height: '2.625rem',
      width: '2.625rem',
    },
    ...(theme.themeName === 'honda' && {
      right: '0.375rem',
    }),
  },
  preferredButtonLabel: {
    fontSize: 0,
  },
  dealerCTAs: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    padding: 0,
    [theme.breakpoints.up('viewportMedium')]: {
      flexWrap: 'wrap',
    },
    [theme.breakpoints.up('viewportLarge')]: {
      flexWrap: 'noWrap',
      justifyContent: 'space-between',
    },
  },
  dealerCTAContainer: {
    justifyContent: 'space-between',
    minWidth: '49%',
    width: 'auto',
    '& a': {
      padding: '1rem 1.0625rem 0.75rem !important',
      width: '100%',
      textAlign: 'center',
    },
  },
  dealerTextButtonContainer: {
    justifyContent: 'space-between',
    width: 'auto',
    '& a': {
      padding: '0.4375rem 0.125rem 0.4375rem 0.75rem',
    },
  },
  dealerCTAText: {
    whiteSpace: 'pre',
  },
  dealerCTALink: {
    display: 'inline',
    textDecoration: 'none',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontFamily: appFonts.AvenirNextDemi.fontFamily,
    fontSize: '0.875rem',
    letterSpacing: 'normal',
    lineHeight: '1.25rem',
    borderBottom: '0',
    color: 'inherit',
  },
  dealerCTAButton: {
    minWidth: '11.25rem',
    width: 'auto',
    '& div': {
      padding: '0.875rem 0.9375rem 0.625rem',
    },
    ...(theme.themeName === 'honda' && {
      height: '2.25rem',
      '& div': {
        padding: 0,
      },
    }),
  },
  dealerCTASvg: {
    height: '0.75rem !important',
    width: '0.5rem  !important',
    marginLeft: '0.3125rem',
    paddingTop: '0.0625rem',
  },
});
